import { Controller } from "@hotwired/stimulus"

const FILTERS = ["q", "sort", "overdue", "agent_id", "user_id", "work_scope", "state", "include_unassigned", "aging", "date_field", "date_preset", "collapsed", "focus"]

export default class extends Controller {
  static targets = ["name", "list", "status"]
  static values = { key: String }

  connect() {
    this.render()
  }

  filterQuery(query) {
    const source = new URLSearchParams(query)
    const result = new URLSearchParams()
    FILTERS.forEach(key => { if (source.has(key)) result.set(key, source.get(key)) })
    return result.toString()
  }

  get views() {
    try {
      const stored = JSON.parse(localStorage.getItem(this.keyValue) || "[]")
      return Array.isArray(stored) ? stored.filter(view => typeof view?.name === "string" && typeof view?.query === "string").slice(0, 8) : []
    } catch (_) {
      return []
    }
  }

  save(event) {
    event.preventDefault()
    const name = this.nameTarget.value.trim().slice(0, 40)
    if (!name) return
    const views = this.views.filter(view => view.name !== name)
    if (views.length >= 8) {
      this.statusTarget.textContent = "Remove a saved view before adding another."
      return
    }
    views.push({ name, query: this.filterQuery(window.location.search) })
    if (this.store(views)) this.nameTarget.value = ""
  }

  remove(event) {
    const views = this.views
    views.splice(Number(event.currentTarget.dataset.index), 1)
    this.store(views)
  }

  store(views) {
    try {
      localStorage.setItem(this.keyValue, JSON.stringify(views))
      this.statusTarget.textContent = "Saved on this browser."
      this.render()
      return true
    } catch (_) {
      this.statusTarget.textContent = "This browser could not save the view."
      return false
    }
  }

  render() {
    this.listTarget.replaceChildren()
    const views = this.views
    if (!views.length) {
      const empty = document.createElement("p")
      empty.className = "board-menu-hint"
      empty.textContent = "No saved views yet"
      this.listTarget.append(empty)
      return
    }
    views.forEach((view, index) => {
      const row = document.createElement("div")
      row.className = "app-menu-item board-view-row"
      const link = document.createElement("a")
      // Only a query string is stored: a saved view cannot change origin or board.
      link.href = `${window.location.pathname}?${this.filterQuery(view.query)}`
      link.className = "board-view-link no-underline"
      link.textContent = view.name
      link.dataset.turbo = "false"
      const remove = document.createElement("button")
      remove.type = "button"
      remove.className = "board-view-remove"
      remove.innerHTML = '<i class="ti ti-x" aria-hidden="true"></i>'
      remove.setAttribute("aria-label", `Remove saved view ${view.name}`)
      remove.dataset.index = index
      remove.dataset.action = "board-saved-views#remove"
      row.append(link, remove)
      this.listTarget.append(row)
    })
  }
}
